import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-digital-card',
    templateUrl: './digital-card.component.html',
    styleUrls: ['./digital-card.component.css'],
    standalone: false
})
export class DigitalCardComponent implements OnInit {
	selected:string = '';
	whatsapp:string = 'https://api.whatsapp.com/send/?';
	facebook:string = 'https://facebook.com/share/share.php/?';
	twitter:string = 'https://x.com/share/?';
	user:any = {};
	// youtube:string = '';
	constructor(
		private router : Router,
		private userService : UserService,
		private titleService: Title,
		private metaService: Meta
	) { 
		this.titleService.setTitle('Digital Visiting Card | Gujarat Tiles Info.')
	}

	colors:any = ['#9bdce4', '#c9f0f5','#3a4d5e33', '#83b8c3','#82c7f161','#99c1e13b', '#cbd6db', '#e3d2e5'];
	
	ngOnInit(): void {
		this.user = this.userService.getUser();
		if(this.user?.digital_card){
			this.selected =  this.user.digital_card_color;
			this.updateShareUrls()
		}
	}

	updateShareUrls () {
		const url = environment.BASE_URL + '/digital-card/' + this.user.id + '/' + this.user.company.slug
		this.whatsapp = this.whatsapp+`text=${url}&preview=true`;
		this.facebook = this.whatsapp+`u=${url}`;
		this.twitter = this.twitter+`url=${url}`;
	}

	chooseCard(color):void{

		if(color == this.selected){
			this.router.navigateByUrl('/' + 'digital-card/' + this.user.id + '/' + this.user.company.slug)
			return;
		}

		this.userService.digitalCardGenerate({color: color}).subscribe(res => {
			if(res.success){
				localStorage.setItem('digital_card_color', res.data.digital_card_color);
				this.selected = res.data.digital_card_color;
				this.updateShareUrls()
				this.router.navigateByUrl(res.data.link)
				this.userService.sucessMessage(res.message);
			}else{
				this.userService.errorMessage(res.message);
			}
		})
	}
}
